var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBancontact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 26,
    fill: "none",
    viewBox: "0 0 40 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v26H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E3764",
    d: "M5 22.17v-4.34h1.34c.97 0 1.6.37 1.6 1.12a1 1 0 0 1-.48.9c.4.19.64.55.64 1.04 0 .87-.64 1.28-1.63 1.28H5Zm.86-2.53h.64c.39 0 .56-.2.56-.55 0-.38-.3-.5-.72-.5h-.48v1.05Zm0 1.77h.53c.52 0 .83-.13.83-.54 0-.4-.26-.57-.75-.57h-.61v1.11Zm3.9.83c-.84 0-1.27-.41-1.27-.97 0-.61.5-.97 1.24-.98.19 0 .37.02.55.05v-.15c0-.38-.21-.55-.63-.55-.28 0-.55.04-.81.14l-.16-.66c.27-.12.7-.19 1.07-.19.91 0 1.36.48 1.36 1.32v1.72a3.1 3.1 0 0 1-1.35.27Zm.52-.7v-.66a2.12 2.12 0 0 0-.44-.05c-.28 0-.5.11-.5.4 0 .26.18.4.51.4.15 0 .3-.03.43-.09Zm1.44.63V19.2c.44-.18.91-.27 1.4-.27.9 0 1.42.45 1.42 1.27v1.97h-.86v-1.9c0-.44-.2-.63-.57-.63-.19 0-.38.03-.55.1v2.43h-.84Zm5.8-3.05-.16.67a1.7 1.7 0 0 0-.7-.15c-.5 0-.77.35-.77.93 0 .64.28.97.82.97.23-.01.47-.07.68-.17l.14.7c-.28.12-.59.18-.9.17-1.02 0-1.61-.64-1.61-1.65 0-1 .58-1.66 1.57-1.66.32 0 .64.06.93.19Zm1.85 3.12c-.95 0-1.55-.66-1.55-1.66 0-.99.6-1.65 1.55-1.65.96 0 1.54.66 1.54 1.65 0 1-.58 1.66-1.54 1.66Zm0-.7c.44 0 .67-.37.67-.96 0-.58-.23-.94-.67-.94-.43 0-.68.36-.68.94 0 .6.25.96.68.96Zm2.03.63V19.2c.45-.18.92-.27 1.4-.27.9 0 1.43.45 1.43 1.27v1.97h-.86v-1.9c0-.44-.2-.63-.57-.63-.19 0-.38.03-.55.1v2.43h-.85Zm4.75.07c-.73 0-1.11-.4-1.11-1.22v-1.34h-.42V19h.42v-.68l.85-.05V19h.7v.68h-.7v1.33c0 .36.15.53.43.53.11 0 .22-.02.33-.04l.04.69c-.17.04-.35.05-.54.05Zm2.16 0c-.85 0-1.27-.41-1.27-.97 0-.61.5-.97 1.24-.98.18 0 .37.02.55.05v-.15c0-.38-.22-.55-.63-.55-.28 0-.56.04-.82.14l-.15-.66c.26-.12.7-.19 1.07-.19.9 0 1.36.48 1.36 1.32v1.72a3.1 3.1 0 0 1-1.35.27Zm.52-.7v-.66a2.2 2.2 0 0 0-.44-.05c-.28 0-.5.11-.5.4 0 .26.18.4.5.4.16 0 .3-.03.44-.09Zm3.75-2.42-.16.67a1.7 1.7 0 0 0-.7-.15c-.5 0-.77.35-.77.93 0 .64.28.97.82.97.23-.01.47-.07.68-.17l.14.7c-.28.12-.59.18-.9.17-1.02 0-1.61-.64-1.61-1.65 0-1 .58-1.66 1.57-1.66.32 0 .64.06.93.19Zm1.88 3.12c-.74 0-1.11-.4-1.11-1.22v-1.34h-.42V19h.42v-.68l.85-.05V19h.69v.68h-.69v1.33c0 .36.15.53.43.53.1 0 .22-.02.33-.04l.04.69c-.18.04-.36.05-.54.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M10.96 15.67c4.52 0 6.78-3.02 9.04-6.03H5v6.03h5.96Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M29.04 3.61c-4.52 0-6.78 3.02-9.04 6.03h15V3.61h-5.96Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 8.03,
    x2: 19.01,
    y1: 12.93,
    y2: 8.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 20.91,
    x2: 32.56,
    y1: 10.16,
    y2: 6.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FBA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancontact);
export default __webpack_public_path__ + "static/media/bancontact.ef5304a1c862801b116388da2d3c561c.svg";
export { ForwardRef as ReactComponent };